code

<template>
    <!--        <img alt="Vue logo" src="./assets/logo.png">-->
    <!--        <HelloWorld msg="Welcome to Your Vue.js App Abdullah"/>-->
    <div class="container">
        <div class="row fh-row justify-content-center">
            <div class="col-md-6 pl-0 pr-0 align-self-center">
                <mdb-card class="z-depth-1 card-height">
                  <mdb-card-header color="white">
                    <div class="container-fluid">
                      <div class="row">
                        <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                          <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                          <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                          <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                        </div>
                      </div>
                    </div>
                  </mdb-card-header>
                    <mdb-card-body class="text-center">
                        <!--                            <mdb-card-image src="./assets/logo.png" alt="" class="img-fluid"></mdb-card-image>-->
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-12 align-self-center">
                              <mdb-progress class="mb-3" style="width: 100%; float:left"
                                            :height="20" :value="$store.state.step/$store.state.totalSteps * 100">
                                {{ $store.state.step }}/{{ $store.state.totalSteps }}
                              </mdb-progress>
                            </div>
                          </div>
                            <div v-if="demo" class="row hh-row" @click="changeDemoElements">
                              <div class="col-12 align-self-center">
                                <h3>Customer Liveness</h3>
                                <h5 v-if="demoStep === 'First'" class="text-primary">{{ $t("firstStep") }}</h5>
                                <h5 v-if="demoStep === 'Second'" class="text-primary">{{ $t("secondStep") }}</h5>
                                <h5 v-if="demoStep === 'Third'" class="text-primary">{{ $t("thirdStep") }}</h5>
                                <p class="w-75 mx-auto">{{ instruction }}</p>
                                <img width="250" :src="animation_src" style="background-color: rgb(219 221 225 / 80%);" />
                              </div>
                              <div class="col-12 align-self-center mt-4">
                                <div class="row justify-content-center text-center">
                                  <div class="col-md-12">
                                    <span class="dot" :class="demoStep === 'First'? 'primary-color-dark': ''"></span>
                                    <span class="dot" :class="demoStep === 'Second'? 'primary-color-dark': ''"></span>
                                    <span class="dot" :class="demoStep === 'Third'? 'primary-color-dark': ''"></span>
                                  </div>
                                  <p><b>{{ $t("nextStepMsg") }}</b></p>
                                </div>
                              </div>
                            </div>
                            <div v-else class="hh-row">
                                <div class="col-12 align-self-center">
<!--                                    <h4>Face Detection</h4>-->
                                    <webcam-capture-open-c-v_-face :screen_type="'face_liveness'"
                                            v-on:captureComplete="handleFaceCapture" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <p class></p>
                                </div>
                            </div>
                        </div>
                    </mdb-card-body>
                  <mdb-card-footer>
                    <div class="col-12 align-self-center">
                      <div class="row justify-content-center text-center">
                        <div class="col-md-12 mb-1 ">
                          <mdb-btn
                              v-if="!demo"
                              :disabled="!validated"
                              @click="$router.push($store.state.configPath[$store.state.step])"
                              style="font-size: 15px" block color="primary" class="next-btn" size="md">
                            {{ $t("next") }}
                            <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                          </mdb-btn>
                          <mdb-btn
                              v-else
                              @click="demo=false"
                              style="font-size: 15px" block color="primary" class="next-btn" size="md">
                            {{ $t("skip") }}
                            <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                          </mdb-btn>
                        </div>
                      </div>
                    </div>
                  </mdb-card-footer>
                </mdb-card>
            </div>
        </div>
        <div id="overlay" v-if="spinner">
            <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <p>{{ $t("waitMsg") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import WebcamCaptureOpenCV_Face from "@/components/WebcamCaptureOpenCV_Face";
    import * as centerFace from "../../assets/3D_Face_Center.gif";
    import * as leftFace from "../../assets/3D_Face_Left.gif";
    import * as rightFace from "../../assets/3D_Face_Right.gif";
    import {i18n} from "../../translations";

    export default {
        name: "About",
        components: {
            // eslint-disable-next-line vue/no-unused-components
            WebcamCaptureOpenCV_Face
            // HelloWorld,
        },
        data() {
            return {
                faceDetected: false,
                validated: false,
                spinner:false,
                demo: true,
                animation_src: centerFace,
                demoStep: "First",
                instruction: this.$t("centerFaceAlignMsg"),
            };
        },
      mounted() {
        i18n.locale = this.$store.state.language
        this.$store.commit('assignStep', this.$route.path)
        this.readStepConfig()
      },
      methods: {
          readStepConfig() {
            const currentStep = this.$store.state.config[this.$store.state.step - 1]
            const idSelfieRequired = currentStep.step_config.id_to_selfie_matching || false
            this.$store.commit("setIDSelfieRequired", idSelfieRequired)
          },
          changeDemoElements() {
            if (this.demoStep === "First") {
              this.animation_src = rightFace
              this.instruction = this.$t("rightFaceAlignMsg")
              this.demoStep = "Second"
            } else if (this.demoStep === "Second") {
              this.animation_src = leftFace
              this.instruction = this.$t("leftFaceAlignMsg")
              this.demoStep = "Third"
            } else if (this.demoStep === "Third") {
              this.demo = false
            }
          },
          showError(message, cancelButton=false) {
            const options = {
              title: message,
              text: '',
              icon: 'question',
              showCancelButton: cancelButton,

              confirmButtonText: this.$t("retryRequest"),
              cancelButtonText: this.$t("no"),
              allowOutsideClick: false,
              allowEscapeKey: false,
              focusConfirm: false,
              customClass: {
                confirmButton: "btn btn-primary btn-md ripple-parent",
                cancelButton: "btn  btn-md ripple-parent"
              },
              buttonsStyling: false,
            };

            this.$swal.fire(options).then(res => {
              if (res.value) {
                window.location.reload();
                // eslint-disable-next-line no-undef
              }
            })

          },
            async handleFaceCapture(image, video) {
                this.spinner = true;

                let formData = new FormData();

                formData.append("image",image)
                if (this.$store.state.session_id!==null){
                  formData.append("session",this.$store.state.session_id)
                }
                else {
                  const urlSearchParams = new URLSearchParams(window.location.search);
                  const params = Object.fromEntries(urlSearchParams.entries());
                  formData.append('meta',params.meta)
                }
                try {
                  let init_session_response = await this.$http.post("/upload-pose-face-frame",formData);
                  this.spinner = false
                  if (init_session_response.data.status === false) {
                    await this.$router.push('/complete')
                  }
                  const urlSearchParams = new URLSearchParams(window.location.search);
                  const params = Object.fromEntries(urlSearchParams.entries());
                  await this.$router.push({path:this.$store.state.configPath[this.$store.state.step], query:params})

                } catch (err) {
                  if (err.response.status === 400){
                    if ('non_field_errors' in err.response && err.response.non_field_errors.length>0){
                      this.showError(err.response.non_field_errors[0])
                    }
                    else if ('data' in err.response){
                      if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length>0){
                        this.showError(err.response.data.non_field_errors[0])
                      }
                      else {
                        if (Array.isArray(err.response.data) && err.response.data.length>0) {
                          let error = err.response.data[0]
                          if (typeof err.response.data[0] !== "string") {
                            error = JSON.stringify(error)
                          }
                          this.showError(error)
                        }
                        else {
                          this.showError(JSON.stringify(err.response.data))
                        }

                      }

                    }
                    else{
                      this.showError(JSON.stringify(err.response))
                    }
                  } else if (err.response && err.response.status === 401) {
                    await this.$router.push('/expired')
                  }
                  else {
                    this.showError(err.response)
                  }
                  this.spinner = false
                }

                this.$store.commit("setExtractTextState", {
                    state: true,
                    data: {
                        full_name: "",
                        passport_no: "",
                        country: "",
                        email: "",
                        address: ""
                    }
                });
            }
        }
    };
</script>
<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

    $image-path: "~@/../mdb/mdbvue/img";
</style>
